/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import commonUtil from '../../../../utils/commonUtil';

const applicationRoutes = commonUtil.getApplicationRoutes();

class HomePage extends Component {
  callToolForMyEvent = () => {
    browserHistory.push(applicationRoutes.toolsEvent);
  }
  componentDidMount() {
    if (document.querySelector('.moreInfo a')) {
      document.querySelector('.moreInfo a').setAttribute('style', 'cursor:pointer');
      document.querySelector('.moreInfo a').addEventListener('click', () => {
        this.callToolForMyEvent();
      });
    }
  }

  render() {
    const data = this.props.EventToolsTargeter && this.props.EventToolsTargeter.data ? this.props.EventToolsTargeter.data : null;
    return (
      <div dangerouslySetInnerHTML={{ __html: data }} />
    );
  }
}

export default HomePage;

